module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_8011.e6d377be.png";